export const LOAD_FINANCED_OFFERS_FOR_CONTRACT_GENERATION_STARTED =
  "LOAD_FINANCED_OFFERS_FOR_CONTRACT_GENERATION_STARTED";
export const LOAD_FINANCED_OFFERS_FOR_CONTRACT_GENERATION_SUCCEEDED =
  "LOAD_FINANCED_OFFERS_FOR_CONTRACT_GENERATION_SUCCEEDED";
export const LOAD_FINANCED_OFFERS_FOR_CONTRACT_GENERATION_FAILED =
  "LOAD_FINANCED_OFFERS_FOR_CONTRACT_GENERATION_FAILED";
export const RESET_FINANCED_OFFERS_FOR_CONTRACT_GENERATION = "RESET_FINANCED_OFFERS_FOR_CONTRACT_GENERATION";
export const FOLDER_INVALIDATED = "Charisma.Leasing.PublishedLanguage.Events.LeasingFolder.FolderInvalidated";
